export default {
    appShell: {
    "menuLabels": [
        "시장 도구",
        "선물 도구",
        "체인 탐색",
        "뉴스 분류"
    ],
    "closeMenu": "메뉴 닫기",
    "menuDescriptions": {
        "collect": "저장한 코인 추적",
        "platform": "거래소 순위 및 거래량",
        "toolOutsidePrice": "장외 거래 가격 비교",
        "toolOutsideDisk": "글로벌 시장 동향",
        "toolSentimentIndex": "공포 및 탐욕 지수",
        "manyEmpty": "롱 및 숏 포지션 비율",
        "hyperliquid": "Hyperliquid 고래 포지션 모니터링",
        "rate": "거래소별 펀딩 비율 비교",
        "toolLargeIncrease": "대규모 포지션 증가 추적",
        "toolLargeDecrease": "대규모 포지션 감소 추적",
        "newChain": "신규 토큰 탐색",
        "whale": "고래 및 기관 보유량",
        "trace": "저장한 주소 추적",
        "inscription": "인스크립션 시장 탐색",
        "toolStableCoin": "공급량, 프리미엄 및 발행",
        "toolCompanyHoldings": "기업 BTC 보유량",
        "toolMTGoxMonitor": "Mt. Gox 지갑 유출 추적",
        "toolBlockChainBrowser": "블록체인 탐색기 찾기",
        "calendar": "주요 경제 이벤트 및 일정",
        "forum": "커뮤니티 게시물 및 토론",
        "application": "시장 앱 및 리소스 탐색"
    }
,
    "back": "뒤로",
    "switchPage": "페이지",
    "collapse": "닫기",
    "intro": "가격, 심리 및 자금 흐름.",
    "home": "TokenTrend 홈",
    "externalLink": "외부 사이트",
    "openExternal": "사이트 열기",
    "externalBridgeHint": "TokenTrend를 떠나 외부 사이트로 이동합니다. 연 뒤에는 왼쪽 가장자리에서 밀어 돌아올 수 있습니다.",
    "light": "라이트 모드",
    "dark": "다크 모드",
    "search": "토큰 검색",
    "closeSearch": "검색 닫기",
    "brandTagline": "시세 · 심리 · 자금",
    "greetingMorning": "좋은 아침입니다,",
    "greetingAfternoon": "좋은 오후입니다,",
    "greetingEvening": "좋은 저녁입니다,",
    "darkModeLabel": "다크 모드",
    "appearance": "화면",
    "themeLight": "라이트",
    "themeDark": "다크",
    "notifications": "알림",
    "closeNotifications": "알림 닫기",
    "notifySample": [
        { "title": "비트코인 $77,000 선 유지", "body": "야간 거래 이후 BTC가 안정적입니다." },
        { "title": "펀딩 비율이 균형을 유지", "body": "주요 거래소는 중립권입니다." },
        { "title": "시장 심리는 중립", "body": "공포 탐욕 지수가 중간 구간에 있습니다." }
    ],
    "workspace": "시장 작업 공간",
    "categories": "페이지 분류",
    "navigation": "주 탐색",
    "groups": [
        "시장",
        "선물",
        "온체인",
        "뉴스",
        "계정"
    ],
    "pages": {
        "market": "시장 개요",
        "platform": "거래소",
        "manyEmpty": "롱 / 숏",
        "hyperliquid": "Hyperliquid 고래 모니터링",
        "hyperliquidDetails": "Hyperliquid 포지션",
        "whale": "고래 및 보유량",
        "burst": "청산 데이터",
        "calendar": "경제 캘린더",
        "burstHeatmapDetails": "청산 히트맵",
        "burstCoinStatisticsDetails": "코인 청산 통계",
        "rate": "펀딩 비율",
        "application": "앱",
        "publicChain": "블록체인",
        "newChain": "신규 토큰",
        "inscription": "인스크립션",
        "consult": "정보",
        "solswap": "토큰 스왑",
        "my": "계정",
        "signIn": "일일 출석",
        "contractCheck": "컨트랙트 검사",
        "userHitNewRobotInfo": "토큰 거래",
        "calendarDetail": "경제 이벤트 상세",
        "consultDetails": "기사 상세",
        "newCoinDetails": "신규 토큰 상세",
        "firmOffer": "실시간 거래"
    }
},
  common: {
    empty: '데이터 없음',
    listLoading: '로드 중...',
    listNoMore: '더 이상은 없어',
    tenThousand: "만",
    hundredMillion: "억",
    copy: '클론',
    copySuccess: '복사 성공! ',
    sendSuccess: '성공적으로 보냈습니다! ',
    confirmText: '확인하다',
    cancelText: '취소',
    contact: '연락하다',
    privacy: "개인정보 처리방침"
  },
  contact: {
    title: '문의하기',
    info1: 'TokenTrend',
    info2: '이메일:',
  },
  homeNav: {
    market: '인용 부호',
    platform: '플랫폼',
    manyEmpty: '롱-숏',
    whale: '고래',
    burst: '변제',
    rate: '비율',
    calendar: '캘린더',
    inscription: '명',
    application: '애플리케이션',
    searchPlaceholder: '주소 또는 통화 문의',
    searchTitle1: '계약',
    searchTitle2: '통화',
    searchList1: '온체인 거래량',
    searchList2: '유통량',
    searchNoResult: '아직 검색결과가 없습니다',
    historyTitle: '이력 검색 이력'
  },
  calendar: {
    title: '달력',
    tit1: '중요한 것만 보기',
    tit2: '경제 데이터',
    tit3: '이벤트',
    week0: '일요일',
    week1: '월요일',
    week2: '화요일',
    week3: '수요일',
    week4: '목요일',
    week5: '금요일',
    week6: '토요일',
    tab1: '데이터/시간',
    tab2: '이전 값/예측',
    tab3: '중요도/발표',
    event1: '국가/시간',
    event2: '이벤트/중요도',
  },
  calendar_details: {
    label1: '최신 발표',
    label2: '발표치',
    label3: '예상치',
    label4: '이전치',
    label5: '다음 발표 시간',
    label6: '발표 주기',
    label7: '중요도',
    label8: '데이터 해설',
    label9: '시장 영향',
    label10: '통계 방법',
    label11: '발표 기관',
    label12: '과거 데이터',
    label13: '1년',
    label14: '2년',
    label15: '5년',

"title": "경제 이벤트 상세"
},
  footerNav: {
    publicChain: '퍼블릭 체인',
    newChain: '새로운 체인',
    inscription: '명',
    smartMoney: '스마트머니',
    consult: '뉴스',
    calendar: "달력",
    my: '내 거',
  },
  login: {
    title: '로그인',
    enterUserName: '이메일/사용자 이름을 입력하세요',
    enterPassword: '비밀번호를 입력 해주세요',
    enterLogin: '로그인',
    loginTip: '로그인...',
    forgotPassword: '비밀번호를 잊어버렸어요',
    register: '계정 등록',
  },
  register: {
    title: '등록하다',
    enterUserName: '사용자 이름',
    enterPassword: '비밀번호',
    enterEmail: '이메일',
    enterCode: '이메일 인증번호',
    inviteCode: '초대코드(선택)',
    sendEmailCode: '인증번호를 보내주세요',
    enterUserNameErr: '사용자 이름을 입력하세요',
    enterUserNameErr2: '사용자 이름은 6~16자의 문자 또는 숫자로 구성됩니다',
    enterPasswordErr: '비밀번호를 입력 해주세요',
    enterPasswordErr2: '비밀번호는 영문 8~18자리, 숫자, 특수기호로 구성됩니다',
    enterEmailErr: '이메일을 입력해주세요',
    enterEmailErr2: '올바른 이메일 주소를 입력해주세요',
    enterCodeErr: '이메일 인증번호를 입력해주세요',
    enterRegister: '등록하다',
    registerSuccess: '등록이 완료되었습니다. 로그인 페이지로 리디렉션됩니다...',
    toLogin: '이미 계정이 있나요? 직접 로그인',
    emailCodeTip: '받은 편지함에서 메시지를 받지 못하면 스팸으로 오판될 수 있습니다. 메일함 스팸에서 확인하십시오.'
  },
  userDelete: {
    title: "계정 삭제",
    enterUserName: "사용자 이름",
    enterPassword: "비밀번호",
    enterEmail: "이메일",
    enterCode: "이메일 인증 코드",
    sendEmailCode: "인증 코드 보내기",
    enterUserNameErr: "사용자 이름을 입력하세요",
    enterPasswordErr: "비밀번호를 입력하세요",
    enterEmailErr: "이메일을 입력하세요",
    enterCodeErr: "이메일 인증 코드를 입력하세요",
    enterRegister: "삭제 확인",
    registerSuccess: "삭제 성공, 로그인 페이지로 이동합니다...",
  },
  forgotPassword: {
    title: '비밀번호를 잊어버렸어요',
    enterEmail: '이메일',
    enterCode: '이메일 인증번호',
    sendEmailCode: '인증번호를 보내주세요',
    enterEmailErr: '이메일을 입력해주세요',
    enterEmailErr2: '올바른 이메일 주소를 입력해주세요',
    enterCodeErr: '이메일 인증번호를 입력해주세요',
    enterPassword: '새 비밀번호',
    enterPasswordErr: '새 비밀번호를 입력해주세요',
    enterPasswordErr2: '비밀번호는 영문 8~18자리, 숫자, 특수기호로 구성됩니다',
    enterBtn1: '취소',
    enterBtn2: '확인하다',
    forgotPasswordSuccess: '수정이 완료되었습니다. 로그인 페이지로 리디렉션됩니다...'
  },
  swap: {
    title: '스왑',
        pay: '지불 수량',
        receive: '예상 수령 수량',
        reverse: '교환 방향 전환',
    title1: '스왑',
    title2: '지갑 연결',
    title3: '지갑 끊기',
    title4: '뒤로',
    title5: '슬리피지',
    title6: '가스 요금',
    title7: '스왑',
    title8: '잔액 부족',
    title9: '참고 환율',
    msg1: '지갑이 연결되었습니다',
    msg2: '지갑이 연결 해제되었습니다',
    msg3: '유효한 금액을 입력해주세요',
    msg4: '먼저 지갑을 연결해주세요',
    msg5: '거래 서명을 위해 OKX 지갑을 열어주세요',
    msg6: '스왑이 성공적으로 완료되었습니다!',
  },
  coinDetails: {
    title: "코인 상세 정보",
    tab1: '거래 데이터',
    tab2: '통화 정보',
    topInfo1: "24H 변동률",
    topInfo2: "24H 최고가",
    topInfo3: "24H 최저가",
    topInfo4: "거래량",
    topInfo5: "24H 거래액",
    topInfo6: "24H 시가",
    topInfo7: "역대 최저가",
    bottomInfo1: "코인",
    bottomInfo2: "전체 이름",
    bottomInfo3: "공식 웹사이트",
    bottomInfo4: "역대 최고가",
    bottomInfo5: "역대 최저가",
    bottomInfo6: "유통량",
    bottomInfo7: "발행 총량",
    bottomInfo8: "최대 공급량",
    bottomInfo9: "상장 날짜",
    bottomInfo10: "Telegram",
    bottomInfo11: "백서 링크",
    bottomInfo12: "인기 순위",
    bottomInfo13: "시가총액 순위",

"trade_txt1": "자금 흐름",
"trade_txt2": "포지션 분석",
"trade_txt3": "롱/숏 비율",
"trade_txt4": "대규모 보유자 포지션",
"trade_txt5": "대규모 보유자 유동성",
"trade_txt6": "대규모 보유자 거래",
"trade_txt7": "대규모 보유자 포지션 분포"
},
  coinTrade: {
    title1: '자금 흐름 분석',
    title2: '24시간 자금 순유입',
    title3: '5일간 주력 순유입',
    title4: '레버리지 대출 잔액 증가율',
    title5: '레버리지 롱숏 비율',
    title6: '개별 마진 대출 비율',
    tableTh11: '주문',
    tableTh12: '매수',
    tableTh13: '매도',
    tableTh14: '순유입',
    tableTh15: '대량 주문',
    tableTh16: '중간 주문',
    tableTh17: '소량 주문',
    tableTh18: '총계',
    chart11: '대량 매수 주문',
    chart12: '중간 매수 주문',
    chart13: '소량 매수 주문',
    chart14: '대량 매도 주문',
    chart15: '중간 매도 주문',
    chart16: '소량 매도 주문',
  },
  insdetail: {
    title: '각인 상세 정보',
    topInfo1: '시가총액',
    topInfo2: '총 거래량',
    topInfo3: '24시간 거래량',
    topInfo4: '보유자 수',
    topInfo5: '거래 건수',
    topInfo6: '메모리 풀 내',
    topInfo7: '진행률',
    bottomInfo1: '이름',
    bottomInfo2: '공급량',
    bottomInfo3: '배포 각인 ID',
    bottomInfo4: '번호',
    bottomInfo5: '단일 주조 한도',
    bottomInfo6: '생성자',
    bottomInfo7: '최종 각인 번호',
    bottomInfo8: '정밀도',
    bottomInfo9: '생성 시간',
    tab1: '거래 내역',
    tab2: '개요',
    cycle1: '24시간',
    cycle2: '7일',
    cycle3: '30일',
  },
  newCoinDetails: {
    topInfo1: '순환',
    topInfo2: '유통율',
    topInfo3: '판매 수량',
    topInfo4: '총 발행량',
    topInfo5: '24시간 증가',
    topInfo6: '최신 가격',
    topInfo7: '가격을 제시하다',
    topInfo8: '예매시간',
    topInfo9: '코인 상장 플랫폼',
    topInfo10: '매출비중',
    topInfo11: '직접링크',
    listTitle: '시장',
    list1: '거래 플랫폼',
    list2: '동전쌍',
    list3: '24시간 거래량',
    list4: '24시간 거래량($)',
    list5: '비율',

"title": "신규 토큰 상세"
},
  platformDetails: {
    title: '플랫폼 세부정보',
    volumn24h: '24시간 거래량',
    title1: '소개',
    content1: '확립된:',
    content2: '등록:',
    content3: 'KYC 인증',
    content4: '양자화 인터페이스',
    content5: '자산',
    content6: '거래 쌍의 수량',
    content7: '공식 웹 사이트',
    isTrue: '예',
    isFalse: '아니요',
    title2: '거래 지원',
    content8: '현물 거래',
    content9: '계약거래',
    content10: 'OTC',
    content11: '명목화폐 거래',
    title3: '관련된 링크들',
    content12: '페이스북',
    content13: '트위터',
    content14: '레딧',
    content15: '전보',
  },
  topHome: {
    marketSentiment: '시장 심리',
        sentimentDetails: '상세 보기',
        sentimentUnavailable: '데이터 없음',
        sentimentIndexBlock1: '감정지수',
    sentimentIndexBlock1_1: '극심한 패닉',
    sentimentIndexBlock1_2: '공황',
    sentimentIndexBlock1_3: '중립적',
    sentimentIndexBlock1_4: '탐욕스러운',
    sentimentIndexBlock1_5: '과도한 탐욕',
    sentimentIndexBlock2: 'BTC 포지션 롱 및 숏',
    sentimentIndexBlock2_1: '황소 이점',
    sentimentIndexBlock2_2: '짧은 장점',
  },
  market: {
    tabs1: '인기',
    tabs2: '상승률',
    tabs3: '하락률',
    tabs4: '새 코인',
    tabs5: '급등',
    tabs6: '시가총액',
    tabs7: '거래량',
    popularTh1: "코인/24H 거래량",
    popularTh2: "가격/24H 거래액",
    popularTh3: "24H 변동",
    newCoinTh1: "코인/상장 시간",
    newCoinTh2: "가격/24H 거래액",
    newCoinTh3: "24H 변동/거래량",
    marketTh1: "코인/시가 총액",
    marketTh2: "가격/24H 거래액",
    marketTh3: "24H 변동/거래량"
  },
  platform: {
    tabs1: '글로벌 거래소 자산 랭킹',
    exchangeTableTh1: '플랫폼',
    exchangeTableTh2: '자산',
    exchangeTableTh3: '공식 웹 사이트',
  },
  manyEmpty: {
    overviewHint: "거래량, 계정 및 포지션의 롱·숏 변화를 확인하세요.",
    topTraders: "상위 트레이더",
    latestRatio: "최신 롱/숏 비율",
    balanced: "균형",
    longBias: "롱 우세",
    shortBias: "숏 우세",
    interval: "시간 간격",
    chartView: "차트 보기",
    shareView: "비중",
    loading: "로딩 중…",
    failed: "불러올 수 없습니다",
    noData: "선택한 조건의 데이터가 없습니다",
    retry: "재시도",
    touchHint: "차트를 길게 눌러 확인",

    title1: '글로벌 계정 롱/숏 비율',
    title2: '상위계정 롱/숏 비율',
    title3: '상위 계좌 포지션 ​​롱-숏 비율',
    progress1: '긴:',
    progress2: '짧은:',
    tableTh1: '교환',
    tableTh2: '롱-숏 비율',
    tableTh3: '매수 포지션 비율',
    tableTh4: '짧은 공유',

"title4": "대규모 거래자 롱/숏 포지션 비율",
"msg1": "롱/숏 비율",
"msg2": "롱",
"msg3": "숏",
"msg4": "거래자 비율",
"msg5": "롱 거래자 %",
"msg6": "숏 거래자 %",
"msg7": "계정 비율",
"msg8": "롱 계정 %",
"msg9": "숏 계정 %",
"msg10": "포지션 비율",
"msg11": "롱 포지션 %",
"msg12": "숏 포지션 %"
},
  whale: {
    holdingsTitle: '회색조 위치 목록',
    holdingsTitle2: '업데이트 시간:',
    holdingsTh1: '포지션 변경',
    holdingsTh1_1: '1 일',
    holdingsTh1_2: '7 일',
    holdingsTh1_3: '30 일',
    holdingsTh2: '프리미엄 요금',
    holdingsTh3: '코인 보유량',
    holdingsTh4: '위치 값',
    contractTitle: '총 계약 포지션',
    contractTh1: '교환',
    contractTh2: '위치값($)',
    contractTh3: '직위 수',
    contractTh4: '15분 변화',
    contractTh5: '1일 변경',
    exchangeTitle: '환전잔액목록',
    exchangeTh1: '교환',
    exchangeTh2: '지갑 개수',
    exchangeTh3: '24시간 변경',
    exchangeTh4: '변화의 7일',
    exchangeTh5: '변화의 30일',
    statistics1: '전체 시가총액',
    statistics2: '24시간 거래량',
    statistics3: '24시간 최저가',
    listRight1: '이체 주소:',
    listRight2: '이체 주소:',
    listRight3: '이체 금액:',
  },
  autosearch: {
    msg: '검색',
    msg1: '키워드를 입력하세요(거래소, 코인 이름)',
    msg2: '초기화',
    msg3: '더 이상 데이터가 없습니다',
    msg4: '관련 데이터를 찾을 수 없습니다',
  },
  burst: {
    explorerView: "청산 차트",
    explorerheatmap: "히트맵",
    explorermap: "청산 지도",
    explorerOtherLeverage: "기타 레버리지",
    explorerCumulativeLong: "누적 롱 청산량",
    explorerCumulativeShort: "누적 숏 청산량",
    explorerClose: "닫기",
    explorerExpand: "확대",
    explorerCoin: "코인",
    explorerScope: "거래소",
    explorerPair: "거래소",
    explorerAll: "전체 시장",
    explorerEstimate: "추정 청산 구간",
    explorerPrice: "최신 참고 가격",
    explorerAbove: "상단 주요 구간",
    explorerBelow: "하단 주요 구간",

    currentPrice: '현재 가격：',
    liquidationTip1: '누적 다건 청산 강도',
    liquidationTip2: '누적 청구서 청산 강도',
    liquidationTip3: '10x 레버',
    liquidationTip4: '25x 레버',
    liquidationTip5: '50x 레버',
    liquidationTip6: '100x 레버',
    heatmapTop: 'Binance, Huobi, OKX의 3대 거래소 종합 데이터에 따르면, {0}USDT의 최대 청산 시점은 {1}에 가깝고, 청산 가치는 {2}USDT입니다. 자본 리스크에 주의하시기 바랍니다.',
    toBurstHeat: '세부',
    heatmapMaximum: '최대 청산 강도',
    heatmapMinimum: '최소',
    heatmapKLine1: 'k선',
    heatmapKLine2: '청산 강도',
    heatmapTip1: '가격',
    heatmapTip2: '청산 강도',
    kLineTip1: '시가',
    kLineTip2: '종가',
    kLineTip3: '최고가',
    kLineTip4: '최저 가격',
    noLogin: '로그인 후 히트맵 보기,',
    toLogin: '로그인으로 이동',
    topBlockH4: '1H 청산',
    topBlockH41: '4H 청산',
    topBlockH42: '12H 청산',
    topBlockH43: '24시간 청산',
    topBlockP: '장거리 주문 비율',
    rankingTitle: '지난 24H, 청산 순위:',
    rankingTh1: '거래소',
    rankingTh2: '수량',
    rankingTh3: '청산USD',
    rankingTh4: 'USD 매수',
    rankingTh5: '빈 주문 USD',
    coinStatisticsH4: '화폐별 청산통계',
    coinStatisticsT1: '1H',
    coinStatisticsT2: '4H',
    coinStatisticsT3: '24H',
    exchangeProportionH4: '네트워크 전체의 모든 거래소에서 청산된 포지션의 비율',
    exchangeProportionT1: '4H',
    exchangeProportionT2: '12H',
    exchangeProportionT3: '24H',
    heatmapDetailsList1Top: '없는',
    heatmapDetailsList1Bottom: '많은',
    heatmapDetailsList1: '방향:',
    heatmapDetailsList2: '가격:',
    heatmapDetailsList3: '변제:',
    coinStatisticsDetailsTh1: '통화',
    coinStatisticsDetailsTh2: '장기주문 청산',
    coinStatisticsDetailsTh3: '단기 주문 청산',
    coinStatisticsDetailsTh4: '시간',
  },
  rate: {
    title1: "자금 비용율",
    type1: "포지션 가중",
    type2: "거래액 가중",
    price: '가격',
    newTitle: '거래소 현재 펀딩 비율 목록',
    newTableTh1: '통화',
    newTableTd1: '예상 비율',
    tableTh1Old: '교환',
    tableTh2Old: '현재 환율',
    tableTh3Old: '최대 속도',
    tableTh4Old: '최저금리',
  },
  application: {
    leftNav1: '애플리케이션',
    leftNav2: '지갑',
    leftNav3: '사회적 접촉',
    visit: '바로가기',
    empty: '아직 없습니다',
    download: '다운로드',
    register: '등록하다'
  },
  publicChain: {
        loadFailed: '불러오지 못했습니다. 다시 시도해 주세요.',
        retry: '다시 시도',

    tableTh1: '페어/시가총액',
    tableTh2: '가격/거래량',
    tableTh3: '변동률/시간',
  },
  inscription: {
    typeAll: '모두',
    tableTh1: '일련번호',
    tableTh2: '토큰 이름',
    tableTh3: '보유자',
    tableTh4: '총 거래 수',
    tableTh5: '가격',
  },
  smartMoney: {
    swipe1: '스마트머니가 우리를 위해 일하게 해주세요',
    swipe2_1: '화폐계 초보자를 위한 특별 맞춤형',
    swipe2_2: '개인 투자자들이 기회를 잡을 수 있도록 돕습니다',
    listTip: '7x24H 모니터링',
    list1Title: '상위 100개 고주파 거래',
    list1Msg: '8대 퍼블릭체인 상위 100개 종합소득/수익률',
    list2Title: '연예인 스마트머니',
    list2Msg: '글로벌 유명인/퍼블릭 체인 창업자/유명 기관 주소 추적',
    list3Title: '레벨1 스마트머니',
    list3Msg: '더 높고 안정적인 발행시장 수익률을 갖춘 스마트머니',
    list4Title: '맞춤형 스마트머니',
    list4Msg: '사용자가 추가한 지갑 주소 추적',
  },
  smartMoneyTop100: {
    topTip: '지난 30일 동안의 주요 DEX 종합 분석 데이터입니다. 잔액은 참고용입니다! ',
    amountUsd: '토큰 총 승률',
    floatProfit: '거래액',
    floatProfitPercent: '거래 수',
    profit: '이익',
    profitPercent: '수익성',
    collectTo: '모으다',
    collectCancel: '즐겨찾기 취소',
    noLogin: '로그인 후 세계에서 수익률이 가장 높은 스마트머니 100위를 확인하고 추적할 수 있습니다.',
    toLogin: '로그인으로 이동',
  },
  smartMoneyStar: {
    title: '연예인 스마트머니',
  },
  smartMoneyOneLevel: {
    title: '레벨1 스마트머니',
  },
  smartMoneyCustom: {
    title: '맞춤형 스마트머니',
    addName: '이름:',
    addNameRules: '이름을 입력해주세요',
    addAddress: '주소:',
    addAddressRules: '주소를 입력해주세요',
    addComment: '주목:',
    addConfirm: '확인하다',
    addSuccess: '성공적으로 추가되었습니다! ',
    delBtn: '삭제',
    delSuccess: '삭제되었습니다! '
  },
  smartMoneyDetails: {
    queryTokenAll: '모두',
    return: '반품',
    dexAddress: '주소:',
    dexHash: '주소:',
    dexChainName: '체인 이름:',
    dexTransactionAmount: '거래 금액:',
    dexTrackerIn: '계약으로 전환:',
    dexTrackerOut: '계약 이전:',
    dexTrackerType: '거래 방향:',
    dexTrackerTypeCon: '{0}{1}은(는) {2}{3}\'로 변환됩니다.',
    dexTransactionTime: '거래 시간:',
    ordinaryHash: '주소:',
    ordinaryFrom: '보낸 사람 주소：',
    ordinaryTo: '수신자 주소：',
    ordinarySymbol: '통화명：',
    ordinaryAmount: '이체 수량：',
    ordinaryTime: '시간：',
  },
  consult: {
    topNav1: '소식',
    topNav2: '발표',
    topNav3: '뉴스',
    detailsShare: '공유하다:',
    detailsTime: '시간'
  },
  my: {
    headPictureSuccess: '성공적으로 수정되었습니다! ',
    toSignIn: '가서 로그인',
    wallet: '지갑 잔액 로그인',
    details: '상세 정보',
    memberTitle: '회원센터',
    memberItem1: '계약서 확인',
    memberItem2: '코인 출금',
    memberItem3: '온라인 고객 서비스',
    memberItem4: '초대링크',
    installMetaMask: '메타마스크를 먼저 설치해주세요! ',
    nav1: '모으다',
    nav2: '길',
    nav3: '팀',
    nav4: '법정',
    nav5: '도구',
    nav6: '언어',
    nav7: "로그아웃",
    nav8: 'API 바인딩',
    nav9: '새로운 로봇을 만들다',
    nav10: "계정 삭제",
    nav11: "로그아웃"
  },
  signIn: {
    title: '{0}일 동안 체크인했습니다',
    btn: '지금 로그인',
    tip1: "{0}분 동안 플랫폼을 탐색하면 로그인 보상을 받을 수 있습니다.",
    tip2: '({0}분 {1}초를 보셨습니다)',
    success: '로그인이 완료되었습니다! ',
    recordTitle: '로그인 기록',
    recordListContent: '시간:',
  },
  signInRecord: {
    title: '지갑 세부정보',
    selectAll: '모두',
    typeSelect1: '로그인 보상',
    typeSelect2: '직접 승격 보상',
    typeSelect3: '팀 보상',
    typeSelect4: '현금인출 공제 신청',
    typeSelect5: '시스템이 증가를 거부합니다',
  },
  contractCheck: {
    riskAssessment: '위험 평가',
    riskInspection: '리스크 체크',
    enterPlaceholder: '계약주소를 입력해주세요',
    enterBtn: '조사하다',
    checkNFT1: ['비악성 NFT', '악성 NFT'],
    checkNFT2: ['오픈소스 아님', '오픈소스'],
    checkNFT3: ['대리점 없는 계약', '대리점과의 계약'],
    checkNFT4: ['확인되지 않음', '확인됨'],
    checkNFT5: ['유명하고 믿을 수 있는 NFT가 아니다', '유명하고 믿을 수 있는 NFT'],
    checkToken1: ['최대 거래금액 또는 최대 토큰 포지션을 수정하는 기능이 없습니다', '최대 거래금액 또는 최대 토큰 포지션을 수정하는 기능이 있습니다'],
    checkToken2: ['소유권을 회복할 수 없습니다', '소유권을 회복할 수 있습니다'],
    checkToken3: ['계약에는 숨은 주인이 없습니다', '계약에는 숨은 주인이 있습니다'],
    checkToken4: ['단일 주소의 최대 거래량 또는 최대 포지션을 제한하는 기능이 없습니다', '단일 주소의 최대 거래량 또는 최대 포지션을 제한하는 기능이 있습니다'],
    checkToken5: ['토큰은 허니팟이 아니다', '토큰은 허니팟이다'],
    checkToken6: ['토큰은 탈중앙화 거래소에서 거래될 수 없습니다.', '토큰은 탈중앙화 거래소에서 거래될 수 있습니다.'],
    checkToken7: ['계약에는 토큰을 발행할 수 있는 능력이 없습니다.', '계약에는 토큰을 발행할 수 있는 능력이 있습니다.'],
    checkToken8: ['오픈소스 아님', '오픈소스'],
    checkToken9: ['대리인이 아닙니다', '대리인입니다'],
    checkToken10: ['계약 소유자는 토큰 보유자 잔액을 변경할 수 없습니다', '계약 소유자는 토큰 보유자 잔액을 변경할 수 있습니다'],
    checkToken11: ['할당된 주소마다 다른 세율을 설정할 수 없습니다', '할당된 주소마다 다른 세율을 설정할 수 있습니다'],
    checkToken12: ['계약은 자멸할 수 없다', '계약은 자멸할 수 있다'],
    checkToken13: ['계약에 거래 냉각 메커니즘이 없습니다', '계약에 거래 냉각 메커니즘이 있습니다'],
    checkToken14: ['토큰 계약을 통해 거래를 중단할 수 없습니다', '토큰 계약을 통해 거래를 중단할 수 있습니다'],
    checkToken15: ['이 토큰은 유명하고 신뢰할 수 있는 토큰이 아닙니다', '이 토큰은 유명하고 신뢰할 수 있는 토큰입니다'],
    botToken1: '소유자 주소',
    botToken2: '오너 잔액',
    botToken3: '소유자가 보유한 토큰의 비율',
    botToken4: '공급량',
    botNFT1: '총 거래량',
    botNFT2: '보유자 수',
    botNFT3: '최고가',
    botNFT4: '24시간 평균 가격',
    botNFT5: '24시간 최저가',
  },
  withdrawal: {
    title: '코인 출금',
    titleTip: '출금 주소는 TRON(TRC-20) 체인의 지갑 주소여야 합니다. 다른 체인의 지갑 주소를 입력하면 영구적인 손실이 발생하며 복구할 수 없습니다. ',
    withdrawalAddress: '귀하의 출금 주소:',
    inputWithdrawalAddress: '출금주소를 입력해주세요',
    number: '수량',
    inputNumber: '수량을 입력해주세요',
    inputNumberErr: '잔액 불충분',
    balance: '균형',
    actualReceipt: '실제 도착:',
    gas: '수수료:',
    tip: '최소 출금 금액은 {0}USDT이고, 출금 수수료는 {1}%입니다. ',
    confirm: '확신하는',
    explain: '온라인 거래는 0~2시간 정도 소요되며 온라인 확인은 포함되지 않습니다',
    submitSuccess: '성공적으로 제출되었습니다'
  },
  withdrawalRecord: {
    title: '출금 기록',
    list1: '주소:',
    list2: '네트워크:',
    list3: '통화:',
    list4: '수량:',
    list5: '취급 수수료:',
    list6: '상태:',
    list7: '시간:',
    status0: '검토 대기 중',
    status1: '통과하다',
    status2: '거절하다',
  },
  bindingApi: {
    title: 'API 바인딩',
    tip: '거래소 API 생성 시 IP 바인딩 필요',
    listTitle: '바인딩 목록',
    unBindBtn: '묶음 해제',
    availableBalance: '사용 가능한 잔액:',
    bindFrom1: '거래소 선택:',
    bindFrom1Err: '거래소를 선택하십시오',
    bindFrom2Err: 'Api key를 입력하십시오',
    bindFrom3Err: 'Secret key를 입력하십시오',
    bindFrom4Err: 'PassPhrase를 입력하십시오(OKX 필수)',
    bindFrom5: '참고:',
    bindFrom5Err: '설명을 입력하십시오',
    bindSuccess: '바인딩 성공',
    unBindSuccess: '묶음 풀기 성공'
  },
  myAsset: {
    disconnect: '연결 끊기'
  },
  collect: {
    title: '모으다',
    amountUsd: '균형',
    floatProfit: '떠 있는',
    floatProfitPercent: '부동이익률',
    profit: '이익',
    profitPercent: '수익성',
    cancel: '즐겨찾기 취소',
    cancelSuccess: '취소 성공! ',
  },
  trace: {
    title: '길',
    list1: '공개 체인 이름:',
    list2: '토큰 이름:',
    list3: '주소:',
    listDel: '삭제',
    listDelSuccess: '삭제되었습니다! ',
  },
  team: {
    title: '팀',
    topInfo1: '직추천 인원',
    topInfo2: '팀 인원',
    topInfoUnit: '명',
    tableTh1: '사용자 이름',
    tableTh2: '등록 시간',
    inviteCode: '초대 코드',
    empty: '아직 직추천 멤버가 없습니다. 초대 링크를 공유하세요.',
  },
  forum: {
    title: '법정',
    toForumPublishNoLogin: '먼저 로그인을 하시고, 로그인 후 게시하시면 됩니다! ',
    publishTitle: '게시 포럼',
    publishContentPlaceholder: '내용을 입력해주세요',
    publishSuccess: '성공적으로 게시되었습니다! ',
    publishConfirm: '풀어 주다',
    forumList1: '전체 텍스트',
    detailsTitle: '포럼 텍스트',
    detailsCommentTitle: '논평',
    detailsCommentInputPlaceholder: '댓글 내용을 입력해주세요',
    detailsCommentInputSuccess: '성공적으로 보냈습니다! ',
    detailsCommentInputBtn: '보내다',
  },
  tool: {
    title: '도구',
    tool1: 'BTC 회사 입장',
    tool2: '감정지수',
    tool3: '멘토구 모니터링',
    tool4: 'OTC 가격',
    tool5: '외부디스크 정보',
    tool6: '대형 트레이더들이 포지션을 늘린다',
    tool7: '대형 트레이더들 포지션 축소',
    tool8: '스테이블코인',
    tool9: '블록체인 브라우저',
  },
  toolCompanyHoldings: {
    title: 'BTC 보유기관',
    titleSub1: '글로벌 기업 BTC 보유 데이터',
    globalDataT1: 'BTC 지주회사',
    globalDataD1: '집',
    globalDataT2: '회사 전체 직위',
    globalDataD2: '지난 7일 동안의 변경사항:',
    globalDataT3: '포지션의 총 가치',
    globalDataD3: '지난 7일 동안의 변경사항:',
    globalDataT4: '포지션은 총 BTC 시장 가치를 설명합니다',
    globalDataD4: '7일 전 비율:',
    titleSub2: 'BTC 지주회사',
    listTh1_1: '위치값($)/',
    listTh1_2: 'BTC 시장 가치 계정',
    listTh2_1: '포지션 BTC/',
    listTh2_2: '지난 7일 동안의 위치 변경',
    listTh3_1: '총 보유 비용/',
    listTh3_2: '평균비용($)',
  },
  toolSentimentIndex: {
    title: '감정지수',
    titleSub1: '공황과 탐욕 지수',
    titleSub1_1: 'BTC 및 주요 주류 통화의 패닉 및 탐욕 지수',
    gauge1: '극심한 패닉',
    gauge2: '공황',
    gauge3: '중립적',
    gauge4: '탐욕스러운',
    gauge5: '과도한 탐욕',
    titleSub2: '역사적 색인',
  },
  toolMTGoxMonitor: {
    title: '멘토구 모니터링',
    titleSub1: '멘투구(MTGox) BTC 콜드월렛',
    topLabel1: '원래 보유했던 BTC 총액',
    topLabel1Span: '원래 값',
    topLabel2: '총 남은 BTC',
    topLabel2Span: '현재 가치',
    topLabel3: 'BTC 변동량 보유',
    titleSub2: 'BTC 콜드월렛 체인의 전송 기록',
    tableTh1: '거래시간',
    tableTh2: '콜드 지갑 주소',
    tableTh3: 'BTC 금액 전송',
  },
  toolOutsidePrice: {
    title: 'OTC 가격',
    th1: '교환',
    th2: '평균 거래 가격',
    th3: '프리미엄',
  },
  toolOutsideDisk: {
    title: '외부디스크 정보',
    itemTitleSpan: '고쳐 쓰다',
    itemTitle2: '개장 시간:',
    beijingTime: '베이징 시간',
    nextDay: '익일',
    itemInfo1: '어제의 수확',
    itemInfo2: '오늘',
    itemInfo3: '오늘의 거래량',
    itemInfo4: '오늘 최고',
    itemInfo5: '오늘 최저',
    itemInfo6: '지난해 최고치',
    itemInfo7: '지난해 최저',
    names: {
      BRENT: '브렌트유',
      DJI: '다우존스',
      HKHSI: '항셍지수',
      INX: 'S&P 500',
      IXIC: '나스닥 종합',
      N225: '닛케이225',
      SH000001: '상해종합',
      SH000300: 'CSI 300',
      WTI: 'WTI 원유',
      XAU: '런던 금(현물)',
    },
  },
  toolLargeIncrease: {
    title: '대형 트레이더들이 포지션을 늘린다',
    tableTh1: '통화',
    tableTh2: '24시간 부침',
    tableTh3: '24H 위치 비율',
    tableTh4: '주간 포지션 비율',
    tableTh5: '월보유비율',
    tableTh6: '글로벌 지수($)',
    tableTh7: '상위 10위권 비율',
    tableTh8: '상위 20위권 비율',
    tableTh9: '상위 50위권 비율',
    tableTh10: '상위 100위권 비율',
  },
  toolLargeDecrease: {
    title: '대형 트레이더들 포지션 축소',
    tableTh1: '통화',
    tableTh2: '24시간 부침',
    tableTh3: '24H 위치 비율',
    tableTh4: '주간 포지션 비율',
    tableTh5: '월보유비율',
    tableTh6: '글로벌 지수($)',
    tableTh7: '상위 10위권 비율',
    tableTh8: '상위 20위권 비율',
    tableTh9: '상위 50위권 비율',
    tableTh10: '상위 100위권 비율',
  },
  toolStableCoin: {
    title: '스테이블코인',
    UsdTopInfo1: 'USDT OTC 평균 가격',
    UsdTopInfo2: '달러 환율',
    UsdTopInfo3: 'USDT 프리미엄 요율',
    UsdTitleSub1: 'USDT 관련 지수 동향',
    UsdIndexQuery1: '7 일',
    UsdIndexQuery2: '30 일',
    UsdTitleSub2: 'USDT 프리미엄 관련 동향',
    relatedTitleSub1: '스테이블코인 개요',
    relatedTopTh1: '통화',
    relatedTopTh2: '오프사이트 평균 가격(엔)/프리미엄 요금',
    relatedTopTh3: '현재 순환',
    relatedTitleSub2: '스테이블코인 유통',
    relatedQuery1: '30 일',
    relatedQuery2: '거의 1년',
    relatedTitleSub3: '스테이블코인 유통비율',
    relatedTitleSub4: '스테이블코인 체인 문제',
    relatedBottomListH4_1: '추가발급',
    relatedBottomListH4_2: '파괴하다',
    relatedBottomListHash: '거래 해시:',
  },
  toolBlockChainBrowser: {
    title: '블록체인 브라우저',
  },
  firmOffer: {

    titleLabel0: '계약 주소:',
    titleLabel1: '보유 주소 수',
    titleLabel2: '고유 거래 주소 수',
    titleLabel3: '거래 건수',
    titleLabel4: '거래 금액',
    titleLabel5: '유동성',
    titleLabel6: '총 시가총액',
    titleLabel7: '생성 시간',
    titleLabel8: '총 락업 시가총액',
    tabs1: '거래 기록',
    tabs2: '풀 변화',
    tabs3: '보유 주소',
    tabs4: '자금',
    transactionTh1: '시간',
    transactionTh2: '가격($)',
    transactionTh3: '거래량($)',
    transactionTh4: '수량',
    transactionTh5: '지갑 주소',
    transactionAddTrace: '이 지갑 주소를 추적하시겠습니까?',
    transactionAddTraceSuccess: '추가 완료!',
    tag1: '매수',
    tag2: '매도',
    tag3: '증가',
    tag4: '감소',
    poolTip: '기본적으로 첫 번째 풀 데이터를 표시합니다.',
    poolTh1: '시간',
    poolTh2: '유형',
    poolTh3: '거래량($)',
    poolTh4: '수량',
    poolTh5: '지갑 주소',
    poolCurrent: '총 주소 수',
    Explain1: '총 주소 수:',
    Explain2: '상위 10개 비율:',
    Explain3: '스나이퍼 수:',
    Explain4: '의심스러운 보유 주소 수:',
    positionTh1: '순위',
    positionTh2: '지갑 주소',
    positionTh3: '보유 비율',
    positionTh4: '수량',
    positionTh5: '24시간 변화',
    positionTh6: '블록 정보',
    financeType1: '상위 매수자',
    financeType2: '상위 매도자',
    financeTh1buy: '순매수',
    financeTh1sell: '순매도',
    financeTh2buy: '매수 금액($)',
    financeTh2sell: '매도 금액($)',
    financeTh3: '사용자',
    addTrace: '현재 주소를 추적하시겠습니까?',
    addTraceSuccess: '추가 완료!',

"title": "토큰 상세"
},

  smartMoneySmall: {
    cycle1: '1점',
    cycle2: '5점',
    cycle3: '30점',
    cycle4: '1시',
    cycle5: '4시',
    cycle6: '1 일',
    klineIndicator1: '구입하다',
    klineIndicator2: '팔다',
    tableTh1: '구매 수량',
    tableTh2: '구매 가격',
    tableTh3: '판매 수량',
    tableTh4: '판매금액',
    tableTh5: '떠 있는',
    tableThAddress: '주소:',
    detailsReturn: '다시 목록으로',
    detailsAddress: '주소:',
    detailsTokenAddress: '토큰 주소:',
    detailsChainName: '체인 이름:',
    detailsTrackerType: '거래 방향:',
    detailsTrackerTypeVal1: '구입하다',
    detailsTrackerTypeVal2: '팔다',
    detailsAmount: '구매 수량:',
    detailsAmountUsd: '구매 금액(USD):',
    detailsTransactionTime: '거래 시간:',
    detailsHash: '거래 해시:',
  },
  hitNewRobot: {
    title: '새로운 로봇',
    topImg1: '과학기술의 미래를 선도하는 스마트 시대',
    topImg2: '새 로봇',
    topImg3: '9월 30일',
    topImg4: '공식적으로 출시됨',
    topImg5: '규칙 보기>>',
    type1: '새 거래소 목록',
    hitNewlistTh1: '토큰 정보',
    hitNewlistTh2: '토큰 가격',
    hitNewlistTh3: '풀 비율',
    hitNewlistTh4: '초기/남은',
    hitNewlistTh5: '시간',
    createBtn: '만들기',
    createTitle: '로봇 생성',
    createLabel1: '교환 이름:',
    createLabel2: '통화쌍 이름:',
    createLabel3: '목록 시간:',
    createLabel7: '사용 가능한 잔액：',
    createLabel4: '예상 구매 수량:',
    createLabel5: '예상 구매 가격:',
    createLabel6: '사재기 시간：',
    createLabel4Err: '예상 구매 수량을 입력하세요',
    createLabel5Err: '예상 구매 가격을 입력하세요',
    createLabel6Err: '사재기 시간을 선택하세요',
    createLabel6Select1: '년 월 일 선택',
    createLabel6Select2: '선택 시 분 초',
    createTip: '구매 가치는 > = 10USDT',
    createSuccess: '생성 성공! ',
    type2: '로봇 목록',
    robotListStatus1: '실행 예정',
    robotListStatus2: '종료됨',
    robotListBinanceStatus1: '주문 접수 성공',
    robotListBinanceStatus2: '등록 실패',
    robotList1: '실행 시간:',
    robotList2: '로봇 취소',
    robotList3: '코인 쌍',
    robotList4: '가격',
    robotList5: '수량',
    robotCancel: '취소 성공',
  },
  hitNewRobotInfo: {
    title: '거래',
    title2: '거래 기록'
  },
  hitNewRobotRule: {
    title: '디지털 화폐 새로운 로봇 모듈 소개',
    h2_1: '핵심 장점:',
    label1_1: '효율적인 알고리즘:',
    label1_2: '심층 통합:',
    label1_3: '빅 데이터 처리:',
    label1_4: '스마트 전략:',
    label1_5: '안전:',
    label1_6: '자동 거래:',
    label1_7: '경험 최적화:',
    p1_1: '내장된 효율적인 알고리즘, 밀리초 수준의 거래 결정 및 시장 역학의 정확한 포착. ',
    p1_2: 'Binance, HTX, OKX 등 주류 거래소의 API를 통합하여 포괄적이고 정확한 데이터를 보장합니다. ',
    p1_3: 'Apache Kafka 및 Flink 기술을 사용하여 실시간으로 시장 데이터를 수집하고 처리합니다. ',
    p1_4: 'TensorFlow 또는 PyTorch 프레임워크와 결합하여 과거 데이터와 추세를 사용하여 새로운 전략을 최적화합니다. ',
    p1_5: '분산 아키텍처와 다중 암호화 기술은 사용자 데이터와 거래의 보안을 보장합니다. ',
    p1_6: '향후에는 DEX 자동화 거래와 효율적인 자산 관리를 실현하기 위해 스마트 계약과 크로스체인 기술을 탐구할 것입니다. ',
    p1_7: '인터페이스와 상호 작용 디자인을 지속적으로 최적화하고 직관적인 데이터 시각화 도구를 제공하며 사용자 경험을 개선합니다. ',
    h2_2: '회원 업그레이드 기준:',
    label2_1: 'v0 → v1：',
    label2_2: 'v1 → v2：',
    label2_3: 'v2 → v3：',
    label2_4: 'v3 → v4：',
    label2_5: 'v4 → v5：',
    label2_6: 'v5 → v6：',
    label2_7: 'v6 → v7：',
    p2_1: '직접 3명을 추천하면 팀이 100명이 됩니다. ',
    p2_2: '직접 5명을 추천하면 팀이 200명이 됩니다. ',
    p2_3: '5명을 직접 푸시했는데 그 중 2명이 v2에 도달했습니다. ',
    p2_4: '5명 직접 승격, 그 중 2명이 v3에 도달했습니다. ',
    p2_5: '5명을 직접 푸시했는데 그 중 2명이 v4에 도달했습니다. ',
    p2_6: '5명 직접 승격, 그 중 2명이 v5에 도달했습니다. ',
    p2_7: '5명 직접 승격, 그 중 2명이 v6에 도달했습니다. ',
    h2_3: '로봇 배포 기준:',
    label3_1: 'V1',
    label3_2: 'V2',
    label3_3: 'V3',
    label3_4: 'V4',
    label3_5: 'V5',
    label3_6: 'V6',
    label3_7: 'V7',
    p3_1: '로봇 1개를 얻습니다. ',
    p3_2: '로봇 3개를 얻으세요. ',
    p3_3: '로봇 5개를 얻으세요. ',
    p3_4: '로봇 6개를 얻으세요. ',
    p3_5: '로봇 7개를 얻으세요. ',
    p3_6: '로봇 9개를 얻으세요. ',
    p3_7: '로봇 10개와 선물로 5개를 더 받아 총 15개의 로봇을 얻으세요. ',
    h2_4: '로봇의 효과적인 작동 조건:',
    label4_1: '연속 체크인:',
    label4_2: '활성화 조건:',
    label4_3: '로그인이 중단되었습니다:',
    p4_1: '로봇의 효과적인 작동을 위해서는 회원들이 매일 지속적으로 체크인을 해야 합니다. ',
    p4_2: '계속 로그인한 회원만 새로운 서비스를 활성화할 수 있습니다. ',
    p4_3: '당일 로그인을 놓친 경우 다음 날 새로운 로봇의 실행이 중지되고 로그인이 재개된 다음 날 0시에 자동으로 활성화됩니다. ',
    h2_5: '요약:',
    p5: '본 플랫폼의 디지털 화폐 신창작 로봇 모듈은 효율적인 알고리즘과 지능적인 전략을 통해 회원에게 자동화되고 효율적이며 안전한 신창작 서비스를 제공합니다. 지속적인 기술 발전을 통해 우리는 계속해서 사용자 경험을 최적화하고, 더욱 다양하고 새로운 옵션을 확장하며, 회원들이 자산 가치를 실현할 수 있도록 도울 것입니다.'
  },
  invite: {
    title: '친구 초대',
    info1: '등록/팀에 가입하도록 친구 초대',
    info2: '로봇 오픈 기회/프로모션 혜택을 받을 수 있는 기회를 얻으세요',
    info3: '안녕하세요! TokenTrend 플랫폼에 오신 것을 환영합니다',
    info4: '통화계의 초보자를 위해 특별히 맞춤화된 새로운 도구는 한 번의 클릭으로 사용할 수 있습니다.',
    btn: '초대 링크 복사'
  }
,
    hyperliquid: {
        searchPlaceholder: '지갑 주소를 입력하여 포지션 조회...',
        searchBtn: '조회',
        title: '고래 포지션 모니터링',
        dataCount: '대호 포지션 {0}개',
        long: '롱',
        short: '숏',
        cross: '교차',
        isolated: '격리',
        positionValue: '포지션 가치',
        positionSize: '포지션 크기',
        entryPrice: '진입 가격',
        markPrice: '마크 가격',
        unrealizedPnl: '미실현 손익',
        noData: '데이터 없음',
        enterAddress: '지갑 주소를 입력하세요',
        enterValidAddress: '유효한 지갑 주소를 입력하세요',
        copyAddress: '주소 복사',
        whale: '고래',
        explorer: '탐색기',
        accountTotalValue: '계정 총 가치',
        perpetual: '무기한',
        freeMarginAvailable: '가용 마진',
        withdrawable: '출금 가능',
        totalPositionValue: '총 포지션 가치',
        leverageRatio: '레버리지 비율',
        marginUsed: '사용 마진',
        usedRatio: '사용률',
        perpTotalValue: '무기한 포지션 총액',
        positionsCount: '{0}개 포지션',
        avgMarginUsedRatio: '평균 마진 사용률',
        directionBias: '방향 편향',
        longExposure: '롱 노출',
        shortExposure: '숏 노출',
        positionDistribution: '포지션 분포',
        longValue: '롱 가치',
        shortValue: '숏 가치',
        roe: 'ROE',
        upnl: '미실현 손익',
        perpPositions: '무기한 포지션 ({0})',
        symbol: '심볼',
        entryAvgPrice: '평균 진입가',
        margin: '마진',
        fundingCost: '자금 비용',
        noPositions: '포지션 없음',
        userAddressRequired: '사용자 주소가 필요합니다',
        addressCopied: '주소가 복사되었습니다',
        copyFailed: '복사 실패',
        bullish: '강세',
        bearish: '약세',
        neutral: '중립'
    },
"burstHeatmapDetails": {"title":"청산 히트맵"},
"burstCoinStatisticsDetails": {"title":"코인 청산 통계"},
"forumPublish": {"title":"게시물 작성"},
"forumDetails": {"title":"커뮤니티 게시물"},
"consultDetails": {"title":"기사 상세"}
}
